import { Pill, PillColor } from '@zorro/design-system/v2/Pill';
import { Tooltip } from '@zorro/design-system/v2/Tooltip';
import { DeepReadonly } from '@zorro/types';
import { Box } from '@zorro/web/design-system';

import { DisplayActionType } from '../PayrollReportTypes';

const actionTypeBadgeConfig: DeepReadonly<{
  [actionType in DisplayActionType]: {
    color: PillColor;
    label: string;
    tooltip: string;
  };
}> = {
  [DisplayActionType.CHANGE_AMOUNTS]: {
    color: 'blue',
    label: 'Change amounts',
    tooltip: 'New enrollment replaces previous. Update payroll data',
  },
  [DisplayActionType.ADD_AMOUNTS]: {
    color: 'green',
    label: 'Add amounts',
    tooltip: 'New enrollment. Add amounts to payroll data',
  },
  [DisplayActionType.REMOVE_AMOUNTS]: {
    color: 'gray',
    label: 'Remove amounts',
    tooltip: 'Enrollment ends. Remove amounts from payroll data',
  },
  [DisplayActionType.RETROACTIVE_CHANGE]: {
    color: 'red',
    label: 'Retroactive update',
    tooltip:
      'Enrollment modified. Update payroll data, and check for retroactive impact on payroll',
  },
  [DisplayActionType.ONE_TIME_CORRECTION]: {
    color: 'yellow',
    label: 'One-time correction',
    tooltip: 'Amount calculated to correct a prorated premium period',
  },
};

type Props = {
  actionType: DisplayActionType;
};

export const PayrollActionTypeBadge = ({ actionType }: Props) => {
  const { color, label, tooltip } = actionTypeBadgeConfig[actionType];

  return (
    <Box>
      <Tooltip label={tooltip} position="top" openDelay={2000}>
        <Pill variant="tag" color={color}>
          {label}
        </Pill>
      </Tooltip>
    </Box>
  );
};
